import { t } from "ttag";

import { CardIcon, EmptyState } from "@/shared/ui";
import { CreditCard } from ".";

export const EmptyPaymentMethod = () => (
  <CreditCard.Root>
    <CreditCard.Chip className="bg-neutral-300" />

    <CreditCard.Content>
      <EmptyState.Root className="gap-1 border-transparent">
        <CardIcon className="size-20" />
        <EmptyState.Description>
          {t`You haven't added a payment method yet.`}
        </EmptyState.Description>
      </EmptyState.Root>
    </CreditCard.Content>
  </CreditCard.Root>
);
